import Vue from 'vue'
import VueRouter from 'vue-router'

import { isUserLoggedIn, checkAccessible, checkWebVersion } from '@/auth/utils'
import apps from './routes/apps'
import pages from './routes/pages'
import desk from './routes/desk'
import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior() {
    if (document.querySelector('section.sub-wrap')) document.querySelector('section.sub-wrap').scrollTo(0, 0)
    if (document.querySelector('section.main-wrap')) document.querySelector('section.main-wrap').scrollTo(0, 0)
    if (document.querySelector('#container')) document.querySelector('#container').scrollTo(0, 0)

    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'app-main' } },
    ...apps,
    ...pages,
    ...desk,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// eslint-disable-next-line consistent-return
router.beforeEach(async (to, _, next) => {
  if (to.name === 'app-preview' || to.name === 'app-preview-survey') {
    return next()
  }

  // ====================================================================================
  // 앱 버전 활성여부 체크 (네이티브 앱이 app-version 헤더를 자동 주입, 서버가 활성여부 판단)
  // ====================================================================================
  // 무한루프 방지를 위해 error-503, not-accessible 페이지는 제외
  if (to.name !== 'not-accessible' && to.name !== 'error-503') {
    if (!checkAccessible()) {
      return next({ name: 'not-accessible' })
    }
    if (window.navigator.userAgent.indexOf('DrInfo') !== -1) { // 닥터인포인 경우 만 버전 체크
      const isActive = await checkWebVersion()
      if (isActive !== true) {
        return next({ name: 'error-503' })
      }
    }
  }
  // ====================================================================================

  if (to.name === 'verification-result') {
    const { crypto_token_id, integrity_value } = to.query

    store.commit('util/setVerifyResult', {
      cryptoTokenId: crypto_token_id,
      integrityValue: integrity_value,
    })

    return next(false)
  }

  if (to.name === 'login-main') {
    if (router.app.$store.getters['util/getAccess'] === false) return next({ name: 'pw-reset-main' })
  }

  if (to.meta.isAuth) {
    const isLoggedIn = await isUserLoggedIn()

    if (!isLoggedIn) next({ name: 'login-main', query: { redirect: to.name } })
  }

  return next()
})

export default router
